import moment from 'moment';
import { ReportAttendanceOperatorDetailText } from '../const';

export const getBreadcrumbItems = ({ id, date, paramsDate, operatorName }) => {
  const formattedDate = moment(date || paramsDate).format('DD MMMM YYYY');
  const monthYear = moment(date || paramsDate).format('MM-YYYY');

  if (id) {
    return [
      {
        title: ReportAttendanceOperatorDetailText.breadcrumbTitleText,
        href: '/report/attendance',
      },
      {
        title: operatorName,
        href: `/report/operator-attendance/${id}?monthYear=${monthYear}`,
      },
      {
        title: formattedDate,
        href: ``,
      },
    ];
  } else {
    return [
      {
        title: ReportAttendanceOperatorDetailText.breadcrumbTitleText,
        href: '/report/attendance',
      },
      {
        title: formattedDate,
        href: ``,
      },
    ];
  }
};
